import Image from "next/image";
import React from "react";

import { WEB_COLORS } from "@/lib/constants";
import {
  Box,
  Stack,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";

/***
 *  schema= [{
      image,
      label,
      hidden
    }]
 */
const ImageStepper = React.memo(({ schema }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const CustomStepIcon = ({ icon, mobileView }) => (
    <>
      <Box
        sx={{
          width: { xs: 10, md: "100%" },
          height: { xs: 10, md: "100%" },
          border: { xs: "1px solid #004135", lg: "none" },
          backgroundColor: { xs: "#00F200", lg: "transparent" },
          borderRadius: "50%",
          mr: { xs: 2.5, md: "auto" },
          ml: { xs: 1, md: "auto" },
        }}
        display={!mobileView && "none"}></Box>
      {!mobileView && (
        <Image
          alt="StepIcon"
          src={icon}
          width={160}
          height={140}
          style={{ position: "relative", zIndex: 1 }}
        />
      )}
    </>
  );

  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    "& .MuiStepConnector-line": {
      marginTop: !isMobile ? "50px" : "-7%",
      border: "1px dashed #004135",
      minHeight: isMobile ? 55 : "",
      position: isMobile ? "absolute" : "",
    },
  }));
  return (
    <Stack mt={4} gap={2}>
      <Stepper
        orientation={isMobile ? "vertical" : "horizontal"}
        alternativeLabel={!isMobile}
        connector={<CustomConnector />}
        activeStep={-1}
        nonLinear={isMobile}
        style={{ position: "relative" }}>
        {schema
          ?.filter((step) => !step.hidden)
          ?.map((step, index) => (
            <Step key={index}>
              <StepLabel
                StepIconComponent={() => (
                  <CustomStepIcon icon={step.image} mobileView={isMobile} />
                )}>
                {!isMobile && (
                  <>
                    <Typography
                      variant="subtitle1"
                      fontSize={{ sm: 14, md: 16 }}
                      fontWeight="bold">
                      {step?.label}
                    </Typography>
                  </>
                )}
                {isMobile && (
                  <Box
                    sx={{
                      p: 1,
                      border: { xs: "1px solid #CCD6D4", md: "none" },
                      borderRadius: "8px",
                    }}
                    md={12}
                    display={"flex"}
                    alignItems={"end"}
                    justifyContent={"space-between"}
                    height={120}>
                    <Box>
                      <Typography fontWeight={350} fontSize={"12px"}>
                        Step 0{index + 1}
                      </Typography>
                      <Typography
                        fontWeight={400}
                        fontSize={"16px"}
                        color={WEB_COLORS.darkTeal}>
                        {step?.label}
                      </Typography>
                    </Box>
                    <Box alignSelf={"end"}>
                      <Image src={step.image} width={80} alt={step.label} />
                    </Box>
                  </Box>
                )}
              </StepLabel>
            </Step>
          ))}
      </Stepper>
    </Stack>
  );
});

export default ImageStepper;
